import LZString from 'lz-string'
import queryString from 'query-string'

export function parse(s) {
  try {
    return JSON.parse(gameUriComponent(s))
  } catch(e) {
    console.error(e)
    return {
      error: e.toString(),
      tries: [],
      word: ''
    }
  }
}

function gameUriComponent(s) {
  return LZString.decompressFromEncodedURIComponent(queryString.parse(s).game)
}

export function stringify(s) {
  return queryString.stringify({
    game: LZString.compressToEncodedURIComponent(JSON.stringify(s)),
  })
}